import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as handlers from "../../../constants/handlers";
import * as license from "../../../constants/license";
import * as modules from "../../../constants/modules";
import * as resources from "../../../constants/resources";
import * as formatHelper from "../../../helpers/formatHelper";
import * as tooltipHelper from "../../../helpers/tooltipHelper";
import * as translationHelper from "../../../helpers/translationHelper";
import * as licenseActions from "../../../actions/licenseActions";

import help from "../../../resources/img/svgicons/help.svg";
import imgReactivate from "../../../resources/img/svgicons/reactive.svg";

class LicenseVersion extends Component {
    componentDidMount() {
        this.props.dispatchIsOnlineActivationAvailableAction();
    }

    handleReactivateButtonClick = () => {
        this.props.dispatchLogOutAndReactivateAction();
    };

    handleRefreshClick = () => {
        this.props.dispatchOnlineLicenseUpdateAction();
    };

    getHintTooltip = (value) => {
        if (this.props.activeHelp) {
            return (
                <div className="hint-tooltip margin-left-10">
                    <ReactSVG
                        src={help}
                        alt="help"
                        data-text={translate(value)}
                        onMouseEnter={tooltipHelper.createTooltip}
                    />
                </div>
            );
        }

        return "";
    };

    getLicenseProduct = () => {
        if (this.props.productPricing) {
            return this.props.softwareName + " Pricing";
        }

        if (this.props.productDispensing) {
            return this.props.softwareName + " Dispensing";
        }

        if (this.props.productPlus) {
            return this.props.softwareName + " Plus";
        }

        if (this.props.productDispensingManual) {
            return this.props.softwareName + " Dispensing Manual";
        }

        if (this.props.productEntry) {
            return this.props.softwareName + " Entry";
        }

        return this.props.softwareName;
    };

    getLicenseStatus = () => {
        if (this.props.licenseStatus === license.STATUS_VALID_UNLIMITED_LICENSE) {
            return translate("license.unlimitedLicense");
        }

        return translate("license.leasedLicense");
    };

    getLicenseExpiration = () => {
        if (this.props.licenseStatus === license.STATUS_VALID_LEASED_LICENSE && this.props.licenseExpiration !== null) {
            return translate("license.expirationDate", {
                dateTime: formatHelper.formatDateTimeUtc(this.props.licenseExpiration)
            });
        }

        return "";
    };

    getLicenseLastUpdate = () => {
        if (this.props.licenseLastUpdate) {
            return translate("license.lastUpdate", {
                dateTime: formatHelper.formatDateTimeUtc(this.props.licenseLastUpdate)
            });
        }

        return "";
    };

    getRefreshButton = () => {
        if (this.props.setupSoftware) {
            return null;
        }

        if (!this.props.onlineActivation) {
            return (
                <div className="col-xs-4">
                    <button
                        className="btn btn-sm btn-dark disabled"
                        data-text={translate("help.licensing.refreshUnavailable")}
                        onMouseEnter={tooltipHelper.createTooltip}
                    >
                        {translate("welcome.refresh")}
                    </button>
                </div>
            );
        }

        if (this.props.loading) {
            return (
                <div className="col-xs-4">
                    <button
                        className="btn btn-sm btn-dark disabled"
                        data-text={translate("welcome.loading")}
                        onMouseEnter={tooltipHelper.createTooltip}
                    >
                        {translate("welcome.refresh")}
                    </button>
                </div>
            );
        }

        return (
            <div className="col-xs-4">
                <button
                    className="btn btn-sm btn-dark"
                    data-text={translate("help.licensing.refresh")}
                    onMouseEnter={tooltipHelper.createTooltip}
                    onClick={this.handleRefreshClick}
                >
                    {translate("welcome.refresh")}
                </button>
            </div>
        );
    };

    getReactivateButton = () => {
        if (this.props.loggedUser.canNotEdit(resources.FUNCTION_REACTIVATE_LICENSE) || this.props.setupSoftware) {
            return <div className="col-xs-4"></div>;
        }

        return (
            <div className="col-xs-4">
                <button
                    className="btn btn-sm btn-dark"
                    data-text={translate("help.licensing.reactivation")}
                    onMouseEnter={tooltipHelper.createTooltip}
                    onClick={this.handleReactivateButtonClick}
                >
                    <ReactSVG src={imgReactivate} className="pull-left btn-icon svg-icon" alt="reactivate" />
                    <Translate value="license.reactivate" />
                </button>
            </div>
        );
    };

    getModuleData = (module) => {
        if (!module.data) {
            return <div />;
        }

        switch (module.code) {
            case modules.MODULE_PRODUCT_GROUPS:
                if (!Array.isArray(module.data)) {
                    return <div />;
                }

                return <div>{module.data.map((group) => '"' + group + '"').join(", ")}</div>;
            case modules.MODULE_COLORINVENT_MATCHING:
            case modules.MODULE_DATACOLOR_MATCHING:
            case modules.MODULE_PARTIAL_UPDATES:
            case modules.MODULE_PACKAGE_CHECK:
            case modules.MODULE_TICKETING:
                return <div />;
            default:
                return <div>{JSON.stringify(module.data)}</div>;
        }
    };

    getModules = () => {
        return this.props.modules.map((module) => {
            return (
                <React.Fragment key={module.code}>
                    <div>{translationHelper.getModuleTranslation(module.code)}</div>
                    <div>{this.getModuleData(module)}</div>
                </React.Fragment>
            );
        });
    };

    render() {
        if (this.props.loggedUser.canNotRead(resources.COMPONENT_LICENSE_STATUS)) {
            return "";
        }

        return (
            <div className="license-version">
                <div className="row">
                    <div className="col-xs-12">
                        <h4 className="color-primary">
                            <Translate value="navigation.menu.licenseVersion" />
                        </h4>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-3">
                        {this.getHintTooltip("help.licensing.versionType")}
                        <Translate value="license.versionType" />
                    </div>
                    <div className="col-xs-5 copy-allowed">{this.getLicenseProduct()}</div>
                    {this.getRefreshButton()}
                </div>
                <div className="row">
                    <div className="col-xs-3">
                        {this.getHintTooltip("help.licensing.versionScope")}
                        <Translate value="license.versionScope" />
                    </div>
                    <div className="col-xs-5 copy-allowed">{this.getLicenseStatus()}</div>
                    {this.getReactivateButton()}
                    <div className="col-xs-offset-3 col-xs-9 copy-allowed">{this.getLicenseExpiration()}</div>
                    <div className="col-xs-offset-3 col-xs-9 copy-allowed">{this.getLicenseLastUpdate()}</div>
                </div>
                {this.props.modules.length > 0 && (
                    <div className="row">
                        <div className="col-xs-3">Modules</div>
                        <div
                            className="col-xs-5"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "max-content auto",
                                rowGap: "5px",
                                columnGap: "20px"
                            }}
                        >
                            {this.getModules()}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        setupSoftware: store.module.setupSoftware,
        productPricing: store.module.productPricing,
        loggedUser: store.login.loggedUser,
        softwareName: store.settings.softwareName,
        productDispensingManual: store.module.productDispensingManual,
        productDispensing: store.module.productDispensing,
        productEntry: store.module.productEntry,
        productPlus: store.module.productPlus,
        licenseStatus: store.license.licenseStatus,
        licenseExpiration: store.license.licenseExpiration,
        licenseLastUpdate: store.license.licenseLastUpdate,
        activeHelp: store.navigation.activeHelp,
        modules: store.module.modules,
        onlineActivation: store.license.onlineActivation,
        loading: store.server.requests.some((r) => r.method === handlers.ONLINE_LICENSE_UPDATE)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogOutAndReactivateAction: () => {
            dispatch(licenseActions.logOutAndReactivate());
        },
        dispatchIsOnlineActivationAvailableAction: () => {
            dispatch(licenseActions.isOnlineActivationAvailable());
        },
        dispatchOnlineLicenseUpdateAction: () => {
            dispatch(licenseActions.updateLicense());
        }
    };
};

export default LicenseVersion = connect(mapStoreToProps, mapDispatchToProps)(LicenseVersion);
